<template>
  <basic-container>
    <mc-exception500></mc-exception500>
  </basic-container>
</template>


<script>
import McException500 from "./../../../blocks/mc-exception500/index.js";

export default {
  components: {
    McException500
  }
};
</script>
